import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CheckoutPaymentStripeTerminalPage } from 'src/app/modals/checkout-payment-stripe-terminal/checkout-payment-stripe-terminal.page';

const routes: Routes = [
  {
    path: '',
    component: CheckoutPaymentStripeTerminalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CheckoutPaymentStripeTerminalPage]
})
export class CheckoutPaymentStripeTerminalPageModule {}
